// Accordion
const accordionItems = document.querySelectorAll('.accordion-item');

accordionItems.forEach((item) => {
    const btn = item.querySelector('.accordion-title');
    const content = item.querySelector('.accordion-content');
    const iconPlus = item.querySelector('.icon-plus');
    const iconMinus = item.querySelector('.icon-minus');

    btn.addEventListener('click', function () {
        const isOpen = item.classList.toggle('open');
        if (isOpen) {
            content.style.maxHeight = content.scrollHeight + 'px';
            iconPlus.classList.add('hidden');
            iconMinus.classList.remove('hidden');
        } else {
            content.style.maxHeight = null;
            iconPlus.classList.remove('hidden');
            iconMinus.classList.add('hidden');
        }
    });

    accordionItems.forEach((other) => {
        if (other !== item) {
            other.classList.remove('open');
            other.querySelector('.accordion-content').style.maxHeight = null;
            other.querySelector('.icon-plus').classList.remove('hidden');
            other.querySelector('.icon-minus').classList.add('hidden');
        }
    });
});
// End Accordion
